/** 404 navigation links — keep in sync with scripts/lib/not-found-links.mjs */

export const NOT_FOUND_LOCALES = {
  fr: {
    title: 'Page introuvable : Leagora',
    description: 'Cette page n\'existe pas ou a été déplacée.',
    h1: 'Page introuvable',
    intro: 'La page que vous cherchez n\'existe pas ou a été déplacée.',
    homeLabel: 'Retour à l\'accueil',
    homeHref: '/',
    sectionsTitle: 'Explorer le site',
    popularTitle: 'Pages populaires',
    intentsTitle: 'Vous cherchiez peut-être',
    sections: [
      { href: '/solutions/', label: 'Solutions vidéo' },
      { href: '/articles/', label: 'Articles' },
      { href: '/secteurs/', label: 'Secteurs' },
      { href: '/comparatifs/', label: 'Comparatifs' },
      { href: '/devis/', label: 'Demander un devis' },
    ],
    popular: [
      { href: '/webrtc/', label: 'WebRTC' },
      { href: '/hebergement-france/', label: 'Hébergement France' },
      { href: '/rgpd/', label: 'RGPD vidéo' },
      { href: '/alternative-zoom-france/', label: 'Alternative Zoom France' },
      { href: '/plateforme-video/', label: 'Plateforme vidéo' },
      { href: '/api-video/', label: 'API vidéo' },
    ],
    intents: [
      { href: '/webrtc/', label: 'Infrastructure WebRTC' },
      { href: '/hebergement-france/', label: 'Hébergement France et souveraineté' },
      { href: '/rgpd/', label: 'Conformité RGPD vidéo' },
      { href: '/alternative-zoom-france/', label: 'Alternative Zoom en France' },
      { href: '/comparatifs/alternative-zoom-heberge-france/', label: 'Zoom hébergé en France' },
      { href: '/solutions/assistance-video-client/', label: 'Assistance vidéo client' },
      { href: '/devis/', label: 'Demander un devis projet vidéo' },
    ],
    otherLocaleLabel: 'English version',
    otherLocaleHref: '/en/',
  },
  en: {
    title: 'Page not found : Leagora',
    description: 'This page does not exist or has been moved.',
    h1: 'Page not found',
    intro: 'The page you are looking for does not exist or has been moved.',
    homeLabel: 'Back to home',
    homeHref: '/en/',
    sectionsTitle: 'Browse the site',
    popularTitle: 'Popular pages',
    intentsTitle: 'You might be looking for',
    sections: [
      { href: '/en/solutions/', label: 'Video solutions' },
      { href: '/articles/', label: 'Articles' },
      { href: '/en/comparisons/', label: 'Comparisons' },
      { href: '/en/quote/', label: 'Request a quote' },
    ],
    popular: [
      { href: '/en/webrtc-video-infrastructure/', label: 'WebRTC' },
      { href: '/en/france-hosted-video-platform/', label: 'France hosting' },
      { href: '/en/gdpr-video-compliance/', label: 'GDPR video' },
      { href: '/en/zoom-alternative-eu/', label: 'Zoom alternative EU' },
      { href: '/en/business-video-platform/', label: 'Business video platform' },
      { href: '/en/video-api/', label: 'Video API' },
    ],
    intents: [
      { href: '/en/webrtc-video-infrastructure/', label: 'WebRTC infrastructure' },
      { href: '/en/france-hosted-video-platform/', label: 'France hosting and sovereignty' },
      { href: '/en/gdpr-video-compliance/', label: 'GDPR video compliance' },
      { href: '/en/zoom-alternative-eu/', label: 'Zoom alternative in the EU' },
      { href: '/en/comparisons/zoom-alternative-gdpr/', label: 'GDPR Zoom alternative' },
      { href: '/en/solutions/customer-video-support/', label: 'Customer video support' },
      { href: '/en/quote/', label: 'Request a video project quote' },
    ],
    otherLocaleLabel: 'Version française',
    otherLocaleHref: '/',
  },
};

export function getNotFoundContent(pathname) {
  return pathname.startsWith('/en') ? NOT_FOUND_LOCALES.en : NOT_FOUND_LOCALES.fr;
}
